<template>
  <b-form-group
    :label="$t(label)"
    class="input-label"
    v-b-tooltip.hover.right
    :title="readonly ? null : $t(tooltip)"
  >
    <b-input-group :id="id" class="vinculado-div is-invalid">
      <vue-autosuggest
        :suggestions="suggestions"
        :limit="5"
        @selected="onSelected"
        v-model="selected"
        :value="value"
        :render-suggestion="renderSuggestion"
        :get-suggestion-value="getSuggestionValue"
        :input-props="this.inputProps"
        @input="onInputChange"
        :state="isValid"
      ></vue-autosuggest>
      <b-overlay
        :show="readonly"
        spinner-type="none"
        spinner-variant="none"
        :opacity="0.8"
      >
        <b-input-group-append>
          <b-button
            size="sm"
            class="vinculado-botoes vinculado-btn-abre"
            variant="info"
            @click="abrePopUpVinculado()"
            >...</b-button
          >
          <b-button
            size="sm"
            class="vinculado-botoes"
            :class="[
              selected != undefined && selected.length > 0
                ? 'vinculado-btn-limpar-on'
                : 'vinculado-btn-limpar',
            ]"
            variant="outline-warning"
            @click="limpaVinculado()"
          ></b-button>
        </b-input-group-append>
      </b-overlay>
    </b-input-group>
  </b-form-group>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest";
import BaseMixin from "@/mixins/BaseMixin";

export default {
  components: { VueAutosuggest },
  mixins: [BaseMixin],
  
  props: {
    label: { type: String, required: true },
    tooltip: { type: String },
    id: {},

    textfield: { type: String, default: "descricao" },
    required: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    readOnlyAfterSelect: { type: Boolean, default: true },
    funcaoBusca: { type: Function, required: true },
    componenteFiltro: { type: String, required: true },

    value: {},
    parametrosBusca: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      selected: null,
      options: [],
      suggestions: [],
      inputProps: { class: "form-control" },
    };
  },

  created() {
    if (this.readonly) {
      this.inputProps.readonly = "true";
    } else {
      delete this.inputProps.readonly;
    }
  },

  watch: {
    readonly(readonlyval) {
      if (readonlyval) {
        this.inputProps.readonly = "readonly";
      } else {
        delete this.inputProps.readonly;
      }
    },

    value: function () {
      this.seleciona(this.value);
    },
  },

  computed: {
    isValid() {
      this.classeRequired();
      return null;
    },
  },

  methods: {
    classeRequired() {
      if (this.required) {
        if (this.value == undefined) {
          this.inputProps.class = "form-control is-invalid";
        } else {
          this.inputProps.class =
            "form-control " + (this.value ? "is-valid" : "is-invalid");
        }
      }
    },

    async onInputChange(text) {
      /* Valida o que o usuário digitou no campo input */
      if (
        text === "" ||
        text === undefined ||
        text.length < configPraca.qtdMinCaracteresAutoComplete
      ) {
        this.options = [];
        this.suggestions = [];
        return;
      }

      this.parametrosBusca[this.textfield] = text;
      await this.funcaoBusca(this.parametrosBusca).then(
        (response) => {
          this.options = response;
        },
        (error) => {
          this.trataErro(error);
        }
      );

      /* Limitando os objetos buscados de acordo com o limite definido */
      this.suggestions = [
        {
          data: this.options.slice(0, this.limit),
        },
      ];
    },

    limpaVinculado() {
      this.options = [];
      this.suggestions = [];
      this.selected = null;
      this.$emit("input", null);
      if (this.readOnlyAfterSelect) {
        this.inputProps.class = "form-control";
        delete this.inputProps.readonly;
      }
    },

    onSelected(option) {
      if (option && option.item) {
        this.seleciona(option.item);
      }
    },

    seleciona(option) {
      if (option) {
        this.options = [];
        this.suggestions = [];
        this.selected = option[this.textfield];
        this.$emit("input", option);
        if (this.readOnlyAfterSelect) {
          this.inputProps.class = "form-control disabled";
          this.inputProps.readonly = "readonly";
        }
        if (this.required) {
          this.inputProps.class = "form-control is-valid";
        }
      }
    },

    renderSuggestion(suggestion) {
      //Aqui colore na lista de sugestões, o fragmento do texto pego na ferramenta de busca
      var arrTxt = suggestion.item[this.textfield];
      var arrTxtUpper = arrTxt.toLowerCase();
      var inpUpper = this.selected.toLowerCase();

      var primParte = arrTxt.substring(0, arrTxtUpper.indexOf(inpUpper));
      var textoSel = arrTxt.substr(
        arrTxtUpper.indexOf(inpUpper),
        inpUpper.length
      );
      var segParte = arrTxt.substring(
        arrTxtUpper.indexOf(inpUpper) + inpUpper.length
      );

      if (primParte != "") {
        return (
          <div>
            <span>{primParte}</span>
            <span class="destaque">{textoSel}</span>
            <span>{segParte}</span>
          </div>
        );
      } else {
        return (
          <div>
            <span class="destaque">{arrTxt.substring(0, textoSel.length)}</span>
            <span>{segParte}</span>
          </div>
        );
      }
    },

    getSuggestionValue(suggestion) {
      return suggestion.item[this.textfield];
    },

    abrePopUpVinculado() {
      /*
			Abaixo irei chamar a página popup.html. Essa página na verdade não existe. Ele é criada utilizando de template a index.html (que está em public).
			Para se criar uma novas página no VueJS, é necessário configurar o arquivo vue.config.js, no bloco pages e adicionar o nome dela, no caso popup e configurar
			pra usar como base o index.html, mas com o nome de popup. Também deve ser criadas um main.js e um app.vue próprios para ela carregar ao abrir.
			Tanto o App.vue quanto o main.js estão na pasta pages e ao chamar o popup.html, essa nova janela irá ler esses arquivosm tendo seu ciclo de vida
			separado do index.html
      */
      var left =
        screen.width / 2 - +configPraca.popup.largura.replace("px", "") / 2; //centralizando janela à esquerda
      var top =
        screen.height / 2 - +configPraca.popup.altura.replace("px", "") / 2; //centralizando janela à direita

      var url =
        document.location.origin +
        "/" +
        document.location.pathname.split("/")[1] +
        "/popup.html?componenteVue=" +
        this.componenteFiltro +
        "&" +
        this.serialize(this.parametrosBusca);

      this.windowRef = window.open(
        url,
        "_blank",
        "width=" +
          configPraca.popup.largura +
          ",height=" +
          configPraca.popup.altura +
          ",top=" +
          top +
          ",left=" +
          left
      );
      this.windowRef.addEventListener("beforeunload", this.closePopup);
    },

    closePopup() {
      if (this.windowRef) {
        this.seleciona(this.windowRef.dataRetorno);
        this.windowRef.close();
        this.windowRef = null;
        this.$emit("close");
      }
    },
  },
};
</script>